module.exports = __webpack_public_path__ + "static/media/strength.0d0fc990.svg";